import React, { useEffect } from 'react';

import { Form } from '@/components';
import { Close } from '@/icons';

import styles from './modal.module.scss';

interface IProps {
  open: boolean;
  onClose: () => void;
}

const Modal: React.FC<IProps> = (props) => {
  const { open, onClose } = props;

  const handleDisableClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    event.stopPropagation();
  };

  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', handleEsc);

    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [onClose]);

  return (
    <dialog open={open} onClick={onClose} className={styles.modal}>
      <div className={styles.modal__body} onClick={handleDisableClick}>
        <button className={styles.modal__close} type='button' onClick={onClose}>
          <Close className={styles.modal__closeIcon} />
        </button>
        <div className={styles.modal__content}>
          <Form />
        </div>
      </div>
    </dialog>
  );
};

export default Modal;
